import React from 'react'
import { observer } from 'mobx-react'
import ApplicationStore from '../../ApplicationStore'
import { SSNInput } from '../commonQuestions/SSN'
import { CompProps } from '../../Editor'

const SSN: React.FC<CompProps> = (props) => {
  return <SSNInput {...props} testID="businessOwner_ssn" />
}

export default {
  title: () => {
    return ApplicationStore.isOwner || ApplicationStore.isAuthorised
      ? 'Owner.SSN'
      : 'Owner.AuthorizedSSN'
  },
  component: observer(SSN),
}
